export const BANNER_TYPE = {
  info: 'info',
  warning: 'warning',
  error: 'error',
}
